export enum DefaultWidgetsCssSelectors {
  inlineForm = ".au-trade-in-form-inline-auto",
  similarCarsWidget = ".au-widget-similar-cars",
  callToActionArea = ".auws-cta-area-TO-BE-REMOVED",
  conversionBox = ".auws-cta-area",
  bookTestDriveForm = ".au-test-drive-form",
  priceAlertWidget = ".auws-price-alert-widget",
  priceRatingWidget = ".au-widget-car-rating",
}

export enum DefaultInlineButtonsCssSelectors {
  inlineCta = ".au-widget-trade-in",
  bookTestDriveCta = ".au-book-test-drive-cta",
  priceAlertCta = ".auws-price-alert-cta",
}
